import React, { useState } from 'react';
import { format, parseISO } from 'date-fns';
import { it } from 'date-fns/locale';
import { CalendarDays } from 'lucide-react';
import { Calendar } from '../../../ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '../../../ui/popover';

// Verbale DPI (scelta utente): la data di consegna si sceglie prima della firma, niente data messa dall'app
export const DataConsegna = ({ valore, onChange }) => {
  const [aperto, setAperto] = useState(false);
  const scelta = valore ? parseISO(valore) : undefined;
  return (
    <div className="rounded-xl border border-orange-200 bg-orange-50 p-2.5 space-y-1" data-testid="firma-data-consegna-box">
      <p className="text-xs font-semibold text-gray-800">Data di consegna dei DPI</p>
      <Popover open={aperto} onOpenChange={setAperto}>
        <PopoverTrigger asChild>
          <button type="button" data-testid="firma-data-consegna"
            className={`w-full h-11 px-3 rounded-lg border border-gray-300 text-sm text-left flex items-center gap-2 ${scelta ? 'text-gray-900' : 'text-gray-500'}`} style={{ background: '#fff' }}>
            <CalendarDays className="h-4 w-4 text-orange-600" />{scelta ? format(scelta, 'dd/MM/yyyy') : 'Scegli la data'}
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start" data-testid="firma-data-consegna-calendario">
          <Calendar mode="single" locale={it} selected={scelta} defaultMonth={scelta} disabled={{ after: new Date() }} initialFocus
            onSelect={(d) => { if (d) { onChange(format(d, 'yyyy-MM-dd')); setAperto(false); } }} />
        </PopoverContent>
      </Popover>
      <p className="text-[11px] text-gray-600">La scrivo sul verbale prima della firma.</p>
    </div>
  );
};
